export default __webpack_public_path__ + "static/sylasActive-54f75e2636218df7a1f22c4c0c34d76c.png";